import {Component, ViewEncapsulation} from '@angular/core';
import {SupportLang} from './shared/lang-picker/support-lang/support-lang';
import {LOG_ENTRIES, LogHelperService} from './shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';

// logger
const log = Log.create(LOG_ENTRIES.app.name);
log.color = LOG_ENTRIES.app.color;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {

  constructor(public supportLang: SupportLang, private logHelper: LogHelperService) {
    this.supportLang.initialLang();
    this.logHelper.iniLoggerConfig();
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/app.component.ts